(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ki-contact"] && !window.DesignMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => { 
        if (window.location.search.indexOf('?contact') !== -1) {
            const targetElement = document.getElementById('join-the-future');
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                setTimeout(() => { 
                  document.body.style.backgroundColor = "#fff";
                }, 1500);
            }
        }

       // if (window.location.search.indexOf('join-the-future') !== -1) {
       //     const targetElement = document.getElementById('join-the-future');
       //     if (targetElement) {
       //         targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
       //     }
       // }

    }, 1000);
});

if (window.location.href.includes('#success')) {
    var form = document.getElementById('hb-form');
    form.style.maxHeight = '0';
    form.style.opacity = '0';
    form.style.overflow = 'hidden';

    document.getElementById('join-the-future').textContent = `Your request has been submitted`;
    document.getElementById('thank-you-description').textContent = "Thank you for joining our email list. We will keep you abreast of updates.";
    document.querySelector('.animation-before').style.display = 'none';
    document.querySelector('.animation-after').style.display = 'block';

    setTimeout(() => {
        document.getElementById('join-the-future').scrollIntoView({ behavior: 'smooth' });
    }, 1000);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ki-diagnostic-tests"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
   //Elements fade in and up
  const targets = ['.section-diagnostic-tests .diagnostic-tests-info', '.section-diagnostic-tests .early-detection-lottie'];
  targets.forEach(target => {
    gsap.to(target, {
      scrollTrigger: {
        trigger: '.section-diagnostic-tests',
        start: 'top 60%',
        end: 'top top',
       scrub: true
      },
      opacity: 1,
     y: 0
    });
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ki-discover-product"] && !window.DesignMode) return;
  try {
    

// Reset body color
gsap.to('body', {
  scrollTrigger: {
    trigger: '.discover-product-section',
    start: 'top 50%',
    end: 'top top',
    scrub: true,
  },
  backgroundColor: 'rgba(220, 255, 221, 0)',
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ki-early-detection"] && !window.DesignMode) return;
  try {
    
  gsap.registerPlugin(ScrollTrigger);

  document.addEventListener('DOMContentLoaded', () => {
    gsap.to('.section-early-detection .inner-content', {
      scrollTrigger: {
        trigger: '.section-early-detection',
        start: 'top bottom',
        end: 'top 50%',
        scrub: true,
      },
      backgroundColor: 'rgba(255, 247, 178, 1)',
    });

    const targets = [
      '.section-early-detection .early-detection-info',
      '.section-early-detection .early-detection-lottie',
    ];
    targets.forEach((target) => {
      gsap.to(target, {
        scrollTrigger: {
          trigger: '.section-early-detection',
          start: 'top 50%',
          end: 'top top',
          scrub: true,
        },
        opacity: 1,
        y: 0,
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ki-future"] && !window.DesignMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {
  const futureImages = document.querySelector('.future-images');

  if (futureImages) {
    if (window.matchMedia("(min-width: 768px)").matches) {
      // Screens bigger than 768px
      gsap.fromTo(futureImages, 
        { x: '8vw' }, 
        {
          x: '-10vw', 
          scrollTrigger: {
            trigger: ".future-section",
            start: 'top bottom',
            end: 'bottom top',
            scrub: true 
          }
        }
      );
    } else {
      // Screens smaller than 768px
      gsap.fromTo(futureImages, 
        { x: '8vw' }, 
        {
          x: '-100vw', 
          scrollTrigger: {
            trigger: ".future-section",
            start: 'top bottom',
            end: 'bottom top',
            scrub: true 
          }
        }
      );
    }
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ki-hero"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('.hero-bg-cards img');

    images.forEach((img, index) => {
      gsap.to(img, {
        opacity: 1,
        y: 0,
        duration: 0.4,
        delay: 0.1 * (index + 3),
      });
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ki-journey"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('.journey-item');

    images.forEach((img) => {
      gsap.fromTo(
        img,
        { opacity: 0 },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: img,
            start: 'top 60%',
            end: 'center center',
            toggleActions: 'play none none none',
          },
        }
      );
    });
  });

  gsap.registerPlugin(ScrollTrigger);

function updateHeader(shade) {
  const header = document.querySelector('.header-wrapper');
  if (shade === 'green') {
    header.classList.remove('white-shade');
    header.classList.add('green-shade');
  } else if (shade === 'white') {
    header.classList.remove('green-shade');
    header.classList.add('white-shade');
  } else {
    header.classList.remove('green-shade', 'white-shade');
  }
}

const sections = [
  {selector: '.hero', shade: 'white'},
  {selector: '.section-early-detection', shade: 'white'},
  {selector: '.all-products-section', shade: 'green'},
  {selector: '.section-diagnostic-tests', shade: 'green'},
  {selector: '.section-journey', shade: 'green'},
  {selector: '.section-take-control', shade: 'green'},
  {selector: '#footer-container', shade: 'white'}
];

sections.forEach(section => {
  ScrollTrigger.create({
    trigger: section.selector,
    start: "top center",
    end: "bottom center",
    onToggle: self => self.isActive && updateHeader(section.shade)
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ki-overview"] && !window.DesignMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

  // Body background animation
  gsap.to('body', {
    scrollTrigger: {
      trigger: '.overview--primary',
      start: 'top 25%',
      end: 'top -400px',
      scrub: true,
    },
    backgroundColor: 'rgba(220, 255, 221, 1)',
  });

  const containers = document.querySelectorAll('.overview-image-container');

  containers.forEach(container => {
    const img = container.querySelector('.overview-image');
    gsap.fromTo(img, 
      { top: '-30%' },
      {
        top: '0%',
        scrollTrigger: {
          trigger: container,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      }
    );
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ki-problem"] && !window.DesignMode) return;
  try {
    
  // Problem section scroll animation
  function makeActive(index) {
    document.querySelectorAll('.problem_item').forEach((item) => item.classList.remove('active'));
    document.querySelectorAll('.problem_item')[index].classList.add('active');
  }

  // Desktop
  function problemDesktop() {
    document.querySelectorAll('.problem_trigger-item').forEach((item, index) => {
      let problemTl = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: 'top 50%',
          end: 'bottom top',
          scrub: 1,
          onEnter: () => {
            makeActive(index);
          },
          onEnterBack: () => {
            makeActive(index);
          },
        },
      });

      const problemItem = document.querySelectorAll('.problem_item')[index];
      problemTl
        .from(problemItem, {
          opacity: 0,
          duration: 0.5,
        })
        .from(problemItem.querySelectorAll('.problem_card-pointer'), {
          opacity: 0,
          y: '1rem',
          duration: 0.3,
          ease: 'power1.out',
          stagger: {
            each: 0.1,
          },
        })
        .from(problemItem.querySelectorAll('.problem_card-heading-wrap'), {
          opacity: 0,
          y: '1rem',
          duration: 0.3,
          ease: 'power1.out',
        })
        .from(problemItem.querySelectorAll('.problem_card-lottie-wrap'), {
          opacity: 0,
          y: '1rem',
          duration: 0.2,
          ease: 'power1.out',
        })
        .from(problemItem, {
          duration: 1.5,
        });
    });
  }

  // Tablet
  function problemTable() {
    document.querySelectorAll('.problem_card-wrap').forEach((item, index) => {
      let problemCardTl = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: 'top 50%',
          end: 'bottom bottom',
        },
      });

      problemCardTl
        .from(item.querySelectorAll('.problem_card-lottie'), {
          opacity: 0,
          y: '2rem',
          duration: 0.3,
          ease: 'power1.out',
        })
        .from(item.querySelectorAll('.line'), {
          opacity: 0,
          yPercent: 50,
          duration: 0.3,
          stagger: {
            each: 0.15,
          },
          ease: 'power1.out',
        })
        .from(item.querySelectorAll('.problem_card-pointer'), {
          opacity: 0,
          y: '2rem',
          duration: 0.3,
          stagger: {
            each: 0.15,
          },
          ease: 'power1.out',
        });
    });
  }

  // Add header shade
  const sections = [
    { selector: '.hero', shade: 'white' },
    { selector: '.section_problem', shade: 'white' },
    { selector: '.overview--primary', shade: 'green' },
    { selector: '.overview--secondary', shade: 'green', multiple: true },
    { selector: '.precision-testing', shade: 'green' },
    { selector: '.future-section', shade: 'green' },
    { selector: '.discover-product-section', shade: 'default' },
    { selector: '.team-section', shade: 'white', multiple: true },
    { selector: '#footer-container', shade: 'white' },
  ];

  sections.forEach((section) => {
    const elements = document.querySelectorAll(section.selector);
    elements.forEach((element) => {
      ScrollTrigger.create({
        trigger: element,
        start: 'top center',
        end: 'bottom center',
        onEnter: () => updateHeader(section.shade),
        onEnterBack: () => updateHeader(section.shade),
      });
    });
  });

  function updateHeader(shade) {
    const header = document.querySelector('.header-wrapper');
    if (shade === 'green') {
      header.classList.remove('white-shade');
      header.classList.add('green-shade');
    } else if (shade === 'white') {
      header.classList.remove('green-shade');
      header.classList.add('white-shade');
    } else {
      header.classList.remove('green-shade', 'white-shade');
    }
  }

  // Breakpoints
  let mm = gsap.matchMedia();

  // Desktop
  mm.add('(min-width: 992px)', () => {
    problemDesktop();
  });

  // Tablet and lower
  mm.add('(max-width: 991px)', () => {
    problemTable();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ki-products"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-info-list-label').forEach((label) => {
      label.addEventListener('click', function () {
        this.classList.toggle('opened');
        const productList = this.closest('.product-info-list');
        const options = productList.querySelector('.product-info-list-options');
        const arrow = productList.querySelector('.product-info-list-arrow');

        if (this.classList.contains('opened')) {
          options.style.display = 'block';
          let optionsHeight = options.scrollHeight;
          options.style.height = '0px';
          setTimeout(() => {
            options.style.height = optionsHeight + 'px';
          }, 10);
          arrow.style.transform = 'rotate(180deg)';
        } else {
          options.style.height = '0px';
          options.addEventListener(
            'transitionend',
            function () {
              options.style.display = 'none';
            },
            { once: true }
          );
          arrow.style.transform = 'rotate(0deg)';
        }

        options.style.transition = 'height 0.25s ease-out';
      });
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    // Body background animation
    gsap.to('body', {
      scrollTrigger: {
        trigger: '.all-products-section',
        start: 'top 25%',
        end: 'top -400px',
        scrub: true,
      },
      backgroundColor: 'rgba(220, 255, 221, 1)',
    });

    // Background color animation
    gsap.to('.all-products-section', {
      scrollTrigger: {
        trigger: '.all-products-section',
        start: 'top bottom',
        end: 'top 50%',
        scrub: true,
      },
      opacity: 1,
    });

    // Elements fade in and up
    const targets = ['.all-products-heading h2', '.all-products-heading .btn-main'];
    targets.forEach((target) => {
      gsap.to(target, {
        scrollTrigger: {
          trigger: '.all-products-section',
          start: 'top 50%',
          end: 'top top',
          scrub: true,
        },
        opacity: 1,
        y: 0,
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ki-take-control"] && !window.DesignMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', () => {
      // Reset body color
      gsap.to('body', {
        scrollTrigger: {
          trigger: '.section-take-control',
          start: 'top 50%',
          end: 'top top',
          scrub: true,
        },
        backgroundColor: 'rgba(220, 255, 221, 0)',
      });

      const items = document.querySelectorAll('.section-take-control h2, .take-control-item');

      items.forEach((item, index) => {
        gsap.fromTo(
          item,
          { opacity: 0, y: 50 },
          {
            opacity: 1,
            y: 0,
            scrollTrigger: {
              trigger: '.section-take-control',
              start: 'top 50%',
              end: 'top top',
              scrub: true,
              toggleActions: 'play none none none',
              delay: 0.1 * index,
            },
          }
        );
      });
  });

  } catch(e) { console.error(e); }
})();
      })();
